export function filterNullOrUndefined(data) {
    return Object.fromEntries(Object.entries(data).filter(([, value]) => typeof value !== 'undefined' && value !== null));
}
//# sourceMappingURL=filterNullOrUndefined.js.map